import { AnimatedNumber } from './AnimatedNumber'
import { CardNote } from './CardNote'
import { FootnoteLink } from './FootnoteLink'

export interface DifferenceCardProps {
  icon: preact.ComponentChildren
  value: number
  label: preact.ComponentChildren
  footnoteId?: number
}

export function DifferenceCard({ icon, value, label, footnoteId }: DifferenceCardProps) {
  return (
    <div className="relative flex items-center justify-start h-20 pl-5 pr-10 overflow-hidden rounded bg-black-20/20 md:flex-1">
      <div className="flex items-center justify-center w-10 shrink-0">{icon}</div>
      <div className="flex items-center justify-center w-20 px-1 mt-1 text-xl font-normal leading-none text-center shrink-0 text-mint-dark/80">
        <AnimatedNumber
          value={value}
          transform={(v: number) => v.toLocaleString('en-AU', { maximumFractionDigits: v >= 10 ? 0 : 2 })}
        />
      </div>
      <div className="flex items-center justify-center leading-snug">{label}</div>
      {!!footnoteId && (
        <CardNote className="w-8 h-8 before:bg-navy/10">
          <span className="text-center pt-1 w-4 text-[11px] leading-none font-normal">
            <FootnoteLink id={footnoteId}>{footnoteId}</FootnoteLink>
          </span>
        </CardNote>
      )}
    </div>
  )
}
